var SelectorUtility = require("lib/shared/SelectorUtility");
var Queries = require("lib/shared/Queries");

export function contact({ state, id }) {
	return state.contacts[id];
}

export function isLoadingContacts({ state, key }) {
	key = key || "index";
	return state.contacts.loading[key];
}

export function deal({ state, id }) {
	return state.deals[id];
}

export function isLoadingDeals({ state, key }) {
	key = key || "index";
	return state.deals.loading[key];
}

export function isLoadingEstimates({ state, key }) {
	key = key || "index";
	return state.estimates.loading[key];
}

export function isLoadingInvoices({ state, key }) {
	key = key || "index";
	return state.invoices.loading[key];
}

export function estimates({ state, filters }) {
	return SelectorUtility.filterBy(state.estimates, filters);
};


// WEBPACK FOOTER //
// ./modules/lib/selectors/CRMSelectors.js